import { BackgroundColors } from '@strength/domain';
import { MdFormatColorFill } from '@teamworksdev/icons';
import { useTranslation } from 'react-i18next';
import {
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from '../../../components/context-menu/context-menu';
import { BrandColors } from '../types';
import { ContextMenuItemIcon } from './context-menu-item-icon';

const PLAIN_SECTION_COLOR = '#D0D5DD';

export function SectionColorContextMenuSub({
  currentColor,
  onColorSection,
  brandColors,
}: {
  currentColor: string | null;
  onColorSection: (color: string) => void;
  brandColors: BrandColors;
}) {
  const { t } = useTranslation();
  return (
    <ContextMenuSub>
      <ContextMenuSubTrigger>
        <ContextMenuItemIcon IconPath={MdFormatColorFill} />
        {t('printoutColor')}
      </ContextMenuSubTrigger>
      <ContextMenuSubContent className="w-fit min-w-0">
        {
          // add brand colors as options
          Object.entries(brandColors).map(([key, color]) => {
            return (
              <ContextMenuItem
                key={color}
                onSelect={() => onColorSection(color)}
                className={
                  currentColor === color ||
                  // if no color is set, use the navbar bottom color as default
                  (key === 'navbarBottomColor' && currentColor === null)
                    ? 'bg-accent text-accent-foreground'
                    : ''
                }
              >
                <div
                  className="h-4 w-4 rounded-full"
                  style={{ backgroundColor: color }}
                />

                {key === 'navbarBottomColor' && (
                  <div className="ml-1 text-xs text-muted-foreground">
                    {t('default')}
                  </div>
                )}
              </ContextMenuItem>
            );
          })
        }
        <ContextMenuSeparator />
        {
          // add plain section color as an option
          <ContextMenuItem
            key="default"
            onSelect={() => onColorSection(PLAIN_SECTION_COLOR)}
            className={
              currentColor === PLAIN_SECTION_COLOR
                ? 'bg-accent text-accent-foreground'
                : ''
            }
          >
            <div
              className="h-4 w-4 rounded-full"
              style={{ backgroundColor: PLAIN_SECTION_COLOR }}
            />
          </ContextMenuItem>
        }
        {BackgroundColors.map((color) => (
          <ContextMenuItem
            key={color}
            onSelect={() => onColorSection(color)}
            className={
              currentColor === color ? 'bg-accent text-accent-foreground' : ''
            }
          >
            <div
              className="h-4 w-4 rounded-full"
              style={{ backgroundColor: color }}
            />
          </ContextMenuItem>
        ))}
      </ContextMenuSubContent>
    </ContextMenuSub>
  );
}
